import Vue from 'vue'
import ElementUI from 'element-ui'
import moment from 'moment';
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import './styles/index.css'
import './styles/partner-links.scss'
import { i18n, currentLocale } from '@/util/i18n'
import { getPromotionConfig } from '@/http/api/home'
import { setPromotionConfig } from '@/config/site-theme'
import { capturePartnerLinksHtml } from '@/config/partner-links'


Vue.use(ElementUI, { locale: currentLocale })
Vue.prototype.$moment = moment
Vue.config.productionTip = false
import modal from './util/modal'
Vue.prototype.$modal = modal
async function bootstrap() {
  // SSI content exists in the prerendered DOM before Vue owns #app.
  // Capture it synchronously so the client mount preserves the static links.
  capturePartnerLinksHtml()

  try {
    const config = await loadPromotionConfig()
    setPromotionConfig(config || {})
  } catch (error) {
    // 配置不可用时不启用活动，避免旧静态文件或构建默认值覆盖后台。
    setPromotionConfig({ enabled: false, auto_apply: false, visible: false, code: '' })
  }

  new Vue({
    i18n,
    router,
    store,
    render: h => h(App),
  }).$mount('#app')
  document.documentElement.removeAttribute('data-spa-shell')
}

async function loadPromotionConfig() {
  const res = await getPromotionConfig();
  return res.data || {};
}

bootstrap()
